import { Module } from 'vuex'
import { RootState, Collection } from '../store-types'
import { MetaPayload } from '@/core/utils/pagination'
import { useUserHttp } from '@/core/api/users'
import { User, UserPayload } from '@/core/models/user'

export type UserCollection = {
    data: Array<User>,
    meta?: MetaPayload,
    links?: any
}

const state: UserCollection = {
    data: <any>[],
    meta: <any>[],
    links: <any>[],
}

export const userCollection: Module<UserCollection, RootState> = {
    namespaced: true,
    state,
    mutations: {
        set: (state: UserCollection, payload: Collection) => {
            state.data = <any>[]
            payload.data.forEach((item: UserPayload) => {
                state.data.push(new User(item))
            })
            state.meta = payload.meta
            state.links = payload.links
        },
    },
    actions: {
        get: <T>(context: any, payload: any): Promise<T> => {
            return new Promise<T>((resolve, reject) => {
                useUserHttp()
                    .get(payload)
                    .then((data: any) => {
                        context.commit('set', data)
                        resolve(data as T)
                    })
                    .catch((response: any) => {
                        reject(response as T)
                    })
            })
        },
        clear: <T>(context: any): Promise<T> => {
            state.data = <any>[]
        }
    },
    getters: {
        get: (state: UserCollection): UserCollection => {
            return state
        }
    }
}
